import { Certificate } from '@legacy-types';

import { useData } from '@shared/api/hooks/useData';
import { CertificatesDataTable } from '@shared/certificates/components/CertificatesDataTable';
import { getCertificates } from '@shared/certificates/endpoints/getCertificates';

export default function UserCertificates({ user }: { user: any }): JSX.Element {
  const certificates = useData<Certificate>({
    get: getCertificates,
    query: { filter: { user_id: user.id } },
    defaults: { sort: '-updated_at' },
  });

  return (
    <CertificatesDataTable
      certificates={certificates}
      admin
      withoutFilters
      avoidPagination
      columns={{ employee: false, updatedAt: false }}
    />
  );
}
